import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { I18n } from 'aws-amplify';
import { useState } from 'react';
import { Button, IconButton, TextField } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import './TelephoneAgentSetting.css';
import ErrorHelper from '@/component/common/ErrorHelper';
import { getInitTelephoneAgentSetting } from '../handler/ProjectProfileManagementHandler';

function TelephoneAgentSetting({
    projectInuseDetail,
    setIsEdited,
    projectType,
    isUsingTelephoneAgent,
    setIsUsingTelephoneAgent,
    phoneNumbers,
    setPhoneNumbers
}) {
    const DEFAULT_COUNTRY = {country: 'jp', dialCode: '81'};

    const [isIncomingCallRestriction, setIsIncomingCallRestriction] = useState(false);
    const [blockedPhoneNumbers, setBlockedPhoneNumbers] = useState('');

    const handleToggleUsingTelephone = () => {
        setIsEdited(true);
        const isUsing = !isUsingTelephoneAgent
        setIsUsingTelephoneAgent(isUsing);
        if (!isUsing) {
            const { initPhoneNumber } = getInitTelephoneAgentSetting(projectInuseDetail);
            setPhoneNumbers(initPhoneNumber)
        }
    }

    const addPhoneNumber = () => {
        if (isUsingTelephoneAgent) {
            setIsEdited(false);
        };
        setPhoneNumbers(prev => [...prev, { id: uuidv4(), tel: '', dialCode: DEFAULT_COUNTRY.dialCode }]);
    };

    const deletePhoneNumber = (id) => {
        setIsEdited(true);
        setPhoneNumbers(prev => prev.filter((phone) => phone.id !== id));
    };

    const handlePhoneNumberChange = (id, value, data) => {
        setIsEdited(true);

        const dialCode = data?.dialCode?.toString() ?? "";

        setPhoneNumbers(prev =>
            prev.map(phone =>
                phone.id === id
                    ? {
                        ...phone,
                        tel: value,
                        dialCode,
                        error: ''
                    }
                    : phone
            )
        );
    };

    const handlePhoneNumberBlur = (e, phoneData) => {
        const blurValue = e.target.value;

        setPhoneNumbers(prev => {
            let hasError = false;
          
            const next = prev.map(phone => {
              if (phone.id !== phoneData.id) return phone;
          
              if (!blurValue || blurValue === `+${phoneData.dialCode}`) {
                hasError = true;
                return {...phone, error: I18n.get('MSG-CM-REQUIRED-INPUT')};
              }
          
              const duplicated = prev.some(
                p => p.id !== phoneData.id && `+${p.tel}` === blurValue
              );
          
              if (duplicated) {
                hasError = true;
                return {...phone, error: I18n.get('MSG_TELEPHONE_TICKET_DUPLICATED_PROJECT_TEL_NUMBER')};
              }
          
              return {...phone, error: ''};
            });
          
            setIsEdited(!hasError);
            return next;
          });
    };


    return (
        <div className="groupSetting category-active">
            <div className="advanced-setting-title">
                <h3>{I18n.get('TELEPHONE_AGENT_FUNCTION')}</h3>
            </div>
            <div className="project-email-setting-group email-setting-function">
                <div className="title-name">{I18n.get('TELEPHONE_AGENT_FUNCTION')}</div>
                <div className="switch-check">
                    <input
                        name="isTelephoneSettingFunction"
                        id="is-telephone-setting-function-switch-id"
                        type="checkbox"
                        checked={isUsingTelephoneAgent}
                        onChange={handleToggleUsingTelephone}
                    />
                    <label htmlFor="is-telephone-setting-function-switch-id"></label>
                </div>
            </div>
            {projectType === Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON && (
                <>
                    <div className="project-email-setting-group email-setting-function">
                        <div className="title-name">
                            {I18n.get('TELEPHONE_NUMBER')}
                            <span className="text-red">*</span>
                        </div>
                    </div>
                    <div className="project-email-setting-group email-setting-function">
                        <div className="telephone-setting-content">
                            <Button
                                className="btn-add-phone"
                                startIcon={<Add />}
                                onClick={addPhoneNumber}
                                disabled={!isUsingTelephoneAgent}
                            >
                                {I18n.get('TELEPHONE_NUMBER_ADD')}
                            </Button>
                            <div className="phone-number-list">
                                {!Utils.isEmptyArray(phoneNumbers) && phoneNumbers.map((phone) => (
                                    <div className="phone-input-group" key={phone.id}>
                                        <div className="phone-number-item">
                                            <PhoneInput
                                                country={DEFAULT_COUNTRY.country}
                                                value={phone.tel}
                                                disabled={!isUsingTelephoneAgent}
                                                onChange={(value, data) => handlePhoneNumberChange(phone.id, value, data)}
                                                onBlur={e => handlePhoneNumberBlur(e, phone)}
                                                autoFormat={false}
                                                countryCodeEditable={false}
                                            />
                                            <IconButton
                                                className="delete-button"
                                                onClick={() => deletePhoneNumber(phone.id)}
                                                disabled={!isUsingTelephoneAgent}
                                            >
                                                <img src="/assets/image/delete-icon.svg" alt="" />
                                            </IconButton>
                                        </div>
                                        <ErrorHelper
                                            isShowError={phone.error}
                                            textError={phone.error}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </>
            )}

            {/* out of scope */}
            {false && (
                <>
                    <div className="separator-line"></div>
                    <div className="project-email-setting-group email-setting-function">
                        <div className="title-name">{I18n.get('TELEPHONE_NUMBER_RESTRICT')}</div>
                        <div className="switch-check">
                            <input
                                name="isIncomingCallRestriction"
                                id="is-incoming-call-restriction-switch-id"
                                type="checkbox"
                                checked={isIncomingCallRestriction}
                                onChange={e => {
                                    setIsIncomingCallRestriction(!isIncomingCallRestriction);
                                }}
                            />
                            <label htmlFor="is-incoming-call-restriction-switch-id"></label>
                        </div>
                    </div>
                    {isIncomingCallRestriction && (
                        <div className="project-email-setting-group email-setting-function">
                            <div className="telephone-setting-content">
                                <div className="description-text">
                                    {I18n.get('TELEPHONE_NUMBER_RESTRICT_DESCRIPTION')}
                                    <br />
                                    {I18n.get('TELEPHONE_NUMBER_RESTRICT_MAX')}
                                </div>
                                <TextField
                                    className="blocked-phone-numbers-input"
                                    multiline
                                    rows={6}
                                    variant="outlined"
                                    value={blockedPhoneNumbers}
                                    onChange={e => setBlockedPhoneNumbers(e.target.value)}
                                    fullWidth
                                />
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default TelephoneAgentSetting;

TelephoneAgentSetting.propTypes = {
    setIsEdited: PropTypes.func.isRequired,
    projectType: PropTypes.string.isRequired,
    isUsingTelephoneAgent: PropTypes.bool.isRequired,
    setIsUsingTelephoneAgent: PropTypes.func.isRequired,
    phoneNumbers: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            tel: PropTypes.string.isRequired,
            dialCode: PropTypes.string,
            error: PropTypes.string,
        })
    ).isRequired,
    setPhoneNumbers: PropTypes.func.isRequired,
};
